const InstallPrompt = ({ promptEvent, onDismiss }) => {
  const handleInstallClick = () => {
    if (promptEvent) {
      promptEvent.prompt();
      promptEvent.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the install prompt');
        } else {
          console.log('User dismissed the install prompt');
        }
        onDismiss();
      });
    }
  };

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '30px',
        left: '50%',
        transform: 'translateX(-50%)',
        background: '#141414',
        color: '#fff',
        padding: '10px 20px',
        borderRadius: '8px',
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.2)',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
      }}
    >
      <span>Install DeepNode for better experience!</span>
      <button
        onClick={handleInstallClick}
        style={{
          background: '#7CACF8',
          border: 'none',
          padding: '8px 16px',
          borderRadius: '4px',
          color: '#fff',
          cursor: 'pointer',
          fontFamily: "'Poppins', sans-serif",
          fontWeight: '500',
        }}
      >
        Install
      </button>
      <button
        onClick={onDismiss}
        style={{
          background: 'transparent',
          border: 'none',
          color: '#fff',
          cursor: 'pointer',
          fontSize: '16px',
        }}
      >
        ✕
      </button>
    </div>
  );
};

export default InstallPrompt;
